import axios, { AxiosError } from 'axios';

//usado para uma requisição mais comum sem muitas restrições 

export  function  apiClient() {

    const api = 
    axios.create({
        baseURL: 'https://alexios.com.br:9597/submasterAccessManagement', // Altere para o domínio
    }) 
    api.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            console.error("Erro na requisição:", error.message);
            return Promise.reject(error);
        }
    );
    return api
}



